import { useState, useEffect, useRef } from 'react';
import Dropdown from './Dropdown';
import { Link } from 'react-router-dom';

const MenuItems = ({ items, depthLevel, closeMenu }) => {
  const [dropdown, setDropdown] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    if (window.innerWidth > 960) setDropdown(true);
  };

  const onMouseLeave = () => {
    if (window.innerWidth > 960) setDropdown(false);
  };

  const toggleDropdown = () => {
    if (window.innerWidth <= 960) {
      setDropdown((prev) => !prev);
    }
  };

  return (
    <li
      className="menu-items"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >

      {/* CASE 1: ITEM WITH SUBMENU */}
      {items.submenu ? (
        <>
          <button
            type="button"
            className="menu-button"
            aria-haspopup="menu"
            aria-expanded={dropdown}
            onClick={toggleDropdown}
          >
            {items.title}
            <span className="arrow" />
          </button>

          <Dropdown
            depthLevel={depthLevel + 1}
            submenus={items.submenu}
            dropdown={dropdown}
          />
        </>
      ) : (
        /* CASE 2: SIMPLE LINK */
        <Link to={items.url} className="menu-link" onClick={closeMenu}>
          {items.title}
        </Link>
      )}
    </li>
  );
};

export default MenuItems;